import { ResourceFaq } from '@intelligent-play-v2/domain';
import { queryBuilder } from '~/api';

export const getFaq = async (): Promise<ResourceFaq[]> => {
  const { data } = await queryBuilder('GET', 'resources/faq');
  return data;
};
